export const productMenuItems = [
  { label: 'Kiosk', slug: 'kiosk' },
  { label: 'Book Drop Box', slug: 'book-drop-box' },
  { label: 'RFID Library Security Gate', slug: 'rfid-library-security-gate' },
  { label: 'RFID Enabled Smart Almirah System', slug: 'rfid-enabled-smart-almirah-system' },
  { label: 'E-Secure Smart Shelf (Library RFID Intelligent Shelf)', slug: 'e-secure-smart-shelf' },
  { label: 'RFID Smart Card', slug: 'rfid-smart-card' },
  { label: 'RFID Tag', slug: 'rfid-tag' },
  { label: 'UHF RFID Flap Barrier', slug: 'uhf-rfid-flap-barrier' },
  { label: 'IP Camera', slug: 'ip-camera' },
  { label: 'Solar Camera with Solar Panel', slug: 'solar-camera-with-solar-panel' },
  { label: 'Biometric Device (Face Recognition)', slug: 'biometric-device-face' },
  { label: 'Biometric Device (Fingerprint)', slug: 'biometric-device-fingerprint' },
  { label: 'GPS Device', slug: 'gps-device' },
  { label: 'Smart Class Monitor', slug: 'smart-class-monitor' },
  { label: 'Issue Return (Biometric Registration)', slug: 'issue-return-biometric' },
  { label: 'Staff Station (Biometric Registration)', slug: 'staff-station-biometric' },
  { label: 'RFID Handle Device', slug: 'rfid-handle-device' },
  { label: 'Barcode Scanner', slug: 'barcode-scanner' },
  { label: 'Standy', slug: 'standy' },
  { label: 'Rommer (Touch Screen Wall)', slug: 'rommer-touch-screen' },
  { label: 'Server Room Establishment', slug: 'server-room-establishment' }
];

export const productMenuLookup = productMenuItems.reduce((accumulator, item) => {
  accumulator[item.slug] = item.label;
  return accumulator;
}, {});
